<template>
    <el-container>
        <el-form :model="deviceInfoForm" :label-width="formLabelWidth + 'px'" :rules="rules" ref="deviceInfoForm" @submit.native.prevent>
            <div :style="getDeviceStyle" class="el-form-height">
                <el-col v-if="this.isAddData && this.treeRangeDisplay && this.belongOrgDisplay" :span="spanNum">
                    <el-form-item :label="$t('common.DEPTMENT')">
                        <td-input v-model="deviceInfoForm.orgName" :maxlength="inputLength" :disabled="this.isbelongOrgDisplay"></td-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="this.isShowDeviceLable" :span="spanNum">
                    <el-form-item :label="$t(deviceLable)" prop="sDeviceId">
                        <td-input :readonly="devIdReadOnly" v-model="deviceInfoForm.sDeviceId" :maxlength="inputLength" :disabled="this.autoIdShow ? this.autoIdDisabled : this.autoIdShow"></td-input>
                        <td-checkbox
                            style="padding-left:10px"
                            v-show="this.isAddData ? this.autoIdShow : this.isAddData"
                            v-model="isAutoIdChecked"
                            :disabled="autoCreateIdDisabled"
                            @change="autoCreateId"
                            >{{ $t('common.AUTO') }}</td-checkbox
                        >
                    </el-form-item>
                </el-col>
                <!-- 添加顶级中间件和域类型两个属性 -->
                <el-col v-if="masterServeDisplay" :span="spanNum">
                    <el-form-item :label="$t('pgCommon.MASTER_SERVE')" prop="iProjectControl">
                        <td-checkbox v-model="deviceInfoForm.iProjectControl" :trueLabel="1" :falseLabel="0" @change="changeCeneral" :disabled="masterServeDisabled"></td-checkbox>
                    </el-form-item>
                </el-col>
                <el-col v-if="domainTypeDisplay" :span="spanNum">
                    <el-form-item :label="$t('pgCommon.DOMAIN_TYPE')" prop="sDomainType">
                        <td-select
                            :url="domainTypeUrl"
                            keys="sCode"
                            text="sValue"
                            :urlParam="domainTypeRequetParam"
                            requestType="POST"
                            @change="domainTypeChange"
                            :placeholder="'common.PLEASE_SELECT'"
                            v-model="deviceInfoForm.sDomainType"
                        ></td-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="parentDevDisplay" :span="spanNum">
                    <el-form-item :label="$t(parentDevLable)" prop="sParentId" v-if="isOrgDevTree">
                        <td-tree-select
                            ref="tdOrgDevTree"
                            nodeKey="id"
                            :defaultProps="deviceProps"
                            :imgloading="true"
                            :multiple="false"
                            :interfaceName="interfaceName"
                            :calInternal="true"
                            :isPaging="true"
                            @isChosen="isChosen"
                            :params="params"
                            :customProp="customProp"
                            v-model="deviceInfoForm.sParentId"
                        ></td-tree-select>
                    </el-form-item>
                    <el-form-item :label="$t(parentDevLable)" prop="sParentId" v-else>
                        <td-select
                            :disabled="parentDevDisabled"
                            :url="url"
                            keys="sId"
                            text="sName"
                            :urlParam="requetParam"
                            requestType="POST"
                            :isPage="true"
                            :placeholder="'common.PLEASE_SELECT'"
                            :pageSize="selectPageSize"
                            v-model="deviceInfoForm.sParentId"
                            @change="belongDevChange"
                            @visibleChange="visibleChange"
                        ></td-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="nameDisplay" :span="spanNum">
                    <el-form-item :label="$t(nameLable)" prop="sName">
                        <td-input v-model="deviceInfoForm.sName" :maxlength="inputLength"></td-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="ipTypeDisplay" :span="spanNum">
                    <el-form-item :label="$t('pgCommon.IP_TYPE')" prop="iIpType">
                        <td-select v-model="deviceInfoForm.iIpType" :clearable="false" :options="iPTypeOptions" @change="iPTypeChange"></td-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="ipDisplay" :span="spanNum">
                    <el-form-item :label="$t('common.IP')" prop="sIp">
                        <td-input v-model="deviceInfoForm.sIp" :disabled="ipDisabled"></td-input>
                    </el-form-item>
                </el-col>
                <el-col v-if="portDisplay" :span="spanNum">
                    <el-form-item class="inputNumberPort" :label="$t(portLable)" prop="iPort">
                        <td-inputNumber v-model="deviceInfoForm.iPort" :min="1" :max="65535"></td-inputNumber>
                    </el-form-item>
                </el-col>
                <el-col v-if="ursIpSegment" :span="spanNum">
                    <el-form-item :label="$t('pgCommon.IP_SEGMENT')" prop="iPSegment">
                        <td-input v-model="deviceInfoForm.iPSegment" :disabled="iPSegmentDisabled"></td-input>
                        <td-checkbox style="padding-left:10px" v-model="deviceInfoForm.usrIpSegment" @change="isIPSegmentChange">{{ $t('pgCommon.ENABLE') }}</td-checkbox>
                    </el-form-item>
                </el-col>
                <!-- 设备动态扩展属性 -->
                <td-dynamic
                    v-if="extendGroupFlg ? true : displayDynamic"
                    ref="tdDynamic"
                    :labelWidth="formLabelWidth + 'px'"
                    v-model="extendElementValue"
                    :groupFlg="interExtendGroupFlg"
                    @tdDynamicHeight="tdDynamicHeight"
                >
                </td-dynamic>
                <el-col v-if="descriptionDisplay" :span="spanNum" style="height: auto">
                    <el-form-item :label="$t('common.DESCRIPTION')" prop="sDescription">
                        <td-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" :rows="2" v-model="deviceInfoForm.sDescription" :maxlength="textAreaLength"></td-input>
                    </el-form-item>
                </el-col>
                <template name="custom">
                    <slot name="custom"></slot>
                </template>
            </div>
        </el-form>
        <el-footer class="footerBtnStyle">
            <div style="text-align: center;">
                <td-button v-if="saveBtnDisplay" type="primary" :loading="loading" @click="submitForm('deviceInfoForm')">{{ $t('common.SAVE') }}</td-button>
                <td-button @click="dlalogClose">{{ $t('common.CANCAL') }}</td-button>
            </div>
        </el-footer>
    </el-container>
</template>
<script>
import deviceApi from '../assets/api.js';
export default {
    props: {
        // 设备Id是否显示
        isShowDeviceLable: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        editItem: {
            trpe: Object,
            default: function() {
                return null;
            }
        },
        /* 表单域标签的宽度设置 */
        devInfoFormLabelWidth: {
            type: [Number, String],
            default: function() {
                return 110;
            }
        },
        // 所属设备是否显示
        devDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 名称是否显示
        nameDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        //ip类型是否显示
        ipTypeDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // IP是否显示
        ipDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 端口是否显示
        portDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // IP段是否显示
        iPSegmentDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 顶级中间件是否显示
        masterServeDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 域类型是否显示
        domainTypeDisplay: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 描述是否显示
        descriptionDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 所属设备是否为组织设备树
        isOrgDevTree: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 所属设备是否可编辑
        belongDevDisabled: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 设备ID是否只读
        devIdReadOnly: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //是否为添加数据
        isAddData: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 每行显示列数
        spanNum: {
            type: Number,
            default: function() {
                return 12;
            }
        },
        // 设备类型
        iDeviceTypes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 组织id
        orgId: {
            type: String
        },
        //所属设备类型
        parentDevType: {
            type: Array,
            default: function() {
                return [];
            }
        },
        //所属设备名称
        parentDevLable: {
            type: String,
            default: function() {
                return 'common.BELONGED_DEVICE';
            }
        },
        // 输入框最大长度
        inputLength: {
            type: Number,
            default: function() {
                return 100;
            }
        },
        // 文本域最大长度
        textAreaLength: {
            type: Number,
            default: function() {
                return 500;
            }
        },
        // 组织信息
        orgInfo: {
            type: Object,
            default: function() {
                return null;
            }
        },

        deviceLable: {
            type: String,
            default: function() {
                return 'common.DEVICE_ID';
            }
        },
        portLable: {
            type: String,
            default: function() {
                return 'common.PORT';
            }
        },
        selectPageSize: {
            type: Number,
            default: function() {
                return 6;
            }
        },
        defaultPort: {
            type: Number,
            default: function() {
                return 3000;
            }
        },
        fatherAutoCreateId: {
            type: Function,
            default: null
        },
        isShowAutoId: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        //是否覆盖初始化编辑数据方法
        hasCoverInitEditData: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //扩展组标识
        extendGroupFlg: {
            type: String
        },
        //所属设备是否必填
        belongDevRequired: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 设备ID是否进行正则校验
        regularCheckID: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //保存时是否处理扩展元素数据
        isHandleExtendData: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //保存时是否处理表单元素数据
        isHandleData: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //保存后，是否触发关闭dialog方法
        isCloseDialog: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        //表单提交前触发的方法
        beforeSubmitForm: Function,
        //是否显示树形区域
        treeRangeDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        //是否显示所属组织
        belongOrgDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 所属组织是否禁用
        isbelongOrgDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 保存按钮是否显示
        saveBtnDisplay: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 是否提示所属设备已修改，请下传设置
        downloadSettingsTip: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 自定义提示信息
        diySuccessMessage: {
            type: String
        },
        //label名称
        nameLable: {
            type: String,
            default: function() {
                return 'common.NAME';
            }
        },
        //ip是否可编辑
        ipDisabled: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //是否启用设备名称自定义校验正则表达式
        customNameRegex: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //是否启用回调提示信息自定义等级
        isEnablePromptInformation: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //提示信息内容(状态码，等级)
        promptCode: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    created() {
        //判断是否校验设备ID
        if (this.regularCheckID) {
            //获取设备ID校验规则
            this.getDeviceIdValidator();
        }
        //若显示域类型，初始化默认值
        if (this.domainTypeDisplay) {
            this.deviceInfoForm.sDomainType = '0';
        }
        //若显示顶级中间件，初始化默认值
        if (this.masterServeDisplay) {
            this.deviceInfoForm.iProjectControl = 0;
        }

        // 为编辑状态则进行初始化数据
        if (this.orgInfo) {
            this.deviceInfoForm.orgName = this.orgInfo.caption;
        }
        if (this.$util.isEmpty(this.extendGroupFlg)) {
            this.getExtendGroupFlg();
        }
        if (this.editItem) {
            this.$nextTick(() => {
                this.initEditData();
            });
        } else {
            this.deviceInfoForm.iPort = this.defaultPort;
            if (this.autoIdShow) {
                this.rules.sDeviceId[0].required = false;
            }
        }
        // 如果是详情,则将域类型值改为0，显示为普通中间件
        if (!this.saveBtnDisplay && !this.$util.isEmpty(this.deviceInfoForm.sDomainType)) {
            this.deviceInfoForm.sDomainType = '0';
        }
    },
    watch: {
        curSteps: {
            immediate: true,
            handler(val) {
                if (val === 0) {
                    let screenHeight = window.screen.height;
                    let height = this.$refs.deviceInfoForm.$el.offsetParent.clientHeight;
                    //分辨率大于1050
                    if (screenHeight >= 1050) {
                        if (height > 815) {
                            this.getDeviceStyle = {
                                height: '650px',
                                maxHeight: '650px',
                                overflowX: 'hidden',
                                overflowY: 'auto'
                            };
                        } else {
                            this.getDeviceStyle = {
                                height: 'auto',
                                maxHeight: '650px'
                            };
                        }
                    } else {
                        if (height > 600) {
                            this.getDeviceStyle = {
                                height: '500px',
                                maxHeight: '500px',
                                overflowX: 'hidden',
                                overflowY: 'auto'
                            };
                        } else {
                            this.getDeviceStyle = {
                                height: 'auto',
                                maxHeight: '500px'
                            };
                        }
                    }
                }
            }
        }
    },
    data() {
        let validateDeviceId = (rule, value, callback) => {
            if (this.isAutoIdChecked) {
                callback();
                return;
            }
            if (this.regularCheckID && !this.$util.isEmpty(this.deviceIdvalidate)) {
                let reg = new RegExp(this.deviceIdvalidate);
                if (!reg.test(value)) {
                    callback(this.validateInfo);
                    return;
                }
            }
            let sId = '';
            if (!this.isAddData) {
                sId = this.editItem.sId;
            }
            let param = {
                sId: sId,
                sDeviceId: value
            };
            deviceApi.checkDeviceIdRepeat(JSON.stringify(param), response => {
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('pgApi.checkDeviceIdRepeat', response);
                }
                if (response.data.content) {
                    callback(this.$t('pgMessage.DEVICE_ID_HAS_EXIST'));
                    this.loading = false;
                    return;
                } else {
                    callback();
                }
            });
        };
        let portCheck = (rule, value, callback) => {
            try {
                if (value < 1) {
                    return callback(new Error(this.$t('pgError.ERROR_PORT')));
                } else if (value > 65535) {
                    this.jobMmessage = '';
                    return callback(new Error(this.$t('pgError.ERROR_PORT')));
                }
                return callback();
            } catch (err) {
                return callback(new Error(this.$t('pgError.ERROR_PORT')));
            }
        };
        let deviceNameCheck = (rule, value, callback) => {
            if (this.regexConfigured) {
                let reg = new RegExp(this.deviceNameRegex);
                if (reg.test(value)) {
                    callback();
                } else {
                    callback(this.deviceNameRegexMessage);
                }
            } else {
                try {
                    let regexTag = window.pangu.common.deviceNameRegexTag + 'PUBLIC';
                    if (this.customNameRegex) {
                        regexTag = window.pangu.common.deviceNameRegexTag + this.iDeviceTypes[0];
                    }
                    let content = {
                        sTag: regexTag
                    };
                    deviceApi.getDictValuesByTag(content, response => {
                        if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                            this.$log.error('deviceApi.getDictValuesByTag', response);
                        }
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$log.error('deviceApi.getDictValuesByTag', response.data.statusMessage);
                        }
                        this.regexConfigured = true;
                        if (Array.isArray(response.data.content) && response.data.content.length > 0) {
                            this.deviceNameRegex = response.data.content[0].sCode;
                            this.deviceNameRegexMessage = response.data.content[0].sValue;
                            let reg = new RegExp(this.deviceNameRegex);
                            if (reg.test(value)) {
                                callback();
                            } else {
                                callback(this.deviceNameRegexMessage);
                            }
                        } else {
                            callback();
                        }
                    });
                } catch (e) {
                    let reg = new RegExp(this.deviceNameRegex);
                    if (reg.test(value)) {
                        callback();
                    } else {
                        callback(this.deviceNameRegexMessage);
                    }
                }
            }
        };
        return {
            getDeviceStyle: {},
            deviceNameRegex: window.pangu.regex.DEV_CAPTION_RULE_NEW,
            deviceNameRegexMessage: this.$t('pgRegex.ERROR_CAPTION_ILLEGAL'),
            interExtendGroupFlg: this.extendGroupFlg,
            parentDevDisabled: this.belongDevDisabled,
            parentDevDisplay: this.devDisplay,
            deviceInfoForm: {
                sName: '',
                sDeviceId: '',
                sIp: '',
                iIpType: 0,
                iPSegment: '',
                usrIpSegment: false,
                iPort: '',
                sDescription: '',
                sParentId: '',
                key: '',
                orgName: '',
                iProjectControl: null,
                sDomainType: ''
            },
            //所属设备-组织设备树使用--开始----
            interfaceName: { query: '/device/queryDeviceOrgTree', search: '/device/queryDeviceOrgTreeByName' },
            params: {
                includeSelf: true, // 查询条件是否包含自己
                parentId: '',
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
                deviceTypeList: this.parentDevType,
                isOwnDomain: true // 查询本给域设备
            },
            deviceProps: {
                children: 'children',
                label: 'caption',
                id: 'id',
                imgName: 'sIcon',
                parentId: 'parentId'
            },
            customProp: ['noPermission'],
            //所属设备-组织设备树使用--结束----
            devList: [],
            keyCode: 'sId',
            textValue: 'sName',
            collapse: true,
            loading: false,
            extendInfo: [],
            adapterList: [],
            requetParam: { iDeviceTypes: this.parentDevType, isOwnDomain: this.saveBtnDisplay, unContainId: !this.$util.isEmpty(this.editItem) ? this.editItem.sId : null },
            trueLabel: '1',
            falseLabel: '0',
            sId: '',
            //校验规则
            deviceIdvalidate: '',
            //校验规则提示信息
            validateInfo: this.$t('pgError.ERROR_INPUT_PROPER_INFO'),
            autoIdShow: this.isShowAutoId,
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'change' },
                    { pattern: window.pangu.regex.DEV_CAPTION_RULE, message: this.$t('pgRegex.ERROR_CAPTION_ILLEGAL') }
                ],
                iPort: [
                    { required: true, message: this.$t('pgError.ERROR_PORT_NOT_NULL'), trigger: 'change' }
                    // { validator: portCheck, trigger: 'blur' }
                ],
                sIp: [{ required: true, message: this.$t('error.ERROR_IP_NULL'), trigger: 'change' }, { pattern: this.$regex.IP_RULE, message: this.$t('pgError.ERROR_IP') }],
                iIpType: [{ required: true, message: this.$t('pgError.ERROR_IP_TYPE_NULL'), trigger: 'change' }],
                iPSegment: [{ required: false, message: this.$t('pgError.ERROR_IP_REGION'), trigger: 'change' }, { pattern: this.$regex.IP_RULE, message: this.$t('pgError.ERROR_IP') }],
                sParentId: [{ required: this.belongDevRequired, message: this.$t('error.ERROR_DEVICE_NULL'), trigger: 'change' }],
                sDeviceId: [
                    // eslint-disable-next-line standard/object-curly-even-spacing
                    { required: true, message: this.$t('pgError.ERROR_DEVICE_NULL'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('pgRegex.PLEASE_INPUT_CREDENT_NUM_RESET') },
                    { validator: validateDeviceId, trigger: 'blur' }
                ],
                sDomainType: [{ required: true, message: this.$t('pgError.ERROR_DOMAIN_TYPE_NULL'), trigger: 'change' }]
            },
            formLabelWidth: this.devInfoFormLabelWidth,
            formInputWidth: '300',
            // 默认自动id
            autoIdDisabled: true,
            isAutoIdChecked: true,
            url: '/device/queryBelongDevice',
            domainTypeUrl: '/setting/dictController/getDictValuesByTypeMid',
            domainTypeRequetParam: { sTag: 'msType' },
            extendElementValue: {},
            displayDynamic: false,
            iPSegmentDisabled: true,
            autoCreateIdDisabled: false,
            masterServeDisabled: false,
            //是否已获取正则配置信息
            regexConfigured: false,
            ursIpSegment: this.iPSegmentDisplay,
            // IP类型数组
            iPTypeOptions: [
                {
                    value: 0,
                    label: this.$t('pgCommon.IP_V4')
                },
                {
                    value: 1,
                    label: this.$t('pgCommon.IP_V6')
                }
            ],
            //超过限定高度之后出现滚动条
            dialogHeight: '',
            //判断tdDynamic组件是否加载完成
            curSteps: {
                type: Number,
                default: -1
            },
            //限制最大高度
            maxDevHeight: ''
        };
    },
    methods: {
        // 获取deviceId校验规则
        getDeviceIdValidator() {
            let param = {};
            deviceApi.getDeviceIdValidator(param, response => {
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('deviceApi.getDeviceIdValidator', response);
                }
                // 校验不为空时
                if (response.data.content) {
                    this.deviceIdvalidate = response.data.content.sCode;
                    this.validateInfo = response.data.content.sValue;
                    this.autoIdShow = false;
                    this.autoIdDisabled = false;
                    this.rules.sDeviceId[0].required = true;
                    this.isAutoIdChecked = false;
                } else {
                    if (this.isAddData) {
                        this.autoIdShow = true;
                    }
                }
            });
        },

        iPTypeChange(value) {
            let iPRuleObj = { pattern: this.$regex.IP_RULE, message: this.$t('pgError.ERROR_IP') };
            if (value == 1) {
                this.ursIpSegment = false;
                //IPv6暂不支持IP段添加
                this.deviceInfoForm.usrIpSegment = false;
                this.deviceInfoForm.iPSegment = '';
                this.isIPSegmentChange(false);
                iPRuleObj = { pattern: window.pangu.regex.IPV6_RULE, message: this.$t('pgError.ERROR_IPV6') };
            } else {
                if (this.isAddData) {
                    this.ursIpSegment = true;
                }
            }
            this.rules.sIp.splice(1, 1, iPRuleObj);
        },
        //启用IP段change事件
        isIPSegmentChange(val) {
            this.iPSegmentDisabled = !val;
            //若启用IP段，需默认自动ID
            this.autoCreateIdDisabled = val;
            if (val) {
                this.isAutoIdChecked = val;
                this.autoIdDisabled = val;
                this.autoCreateId(val);
            }
            this.rules.iPSegment[0].required = val;
            let iPCheck = (rule, value, callback) => {
                if (this.ursIpSegment && !this.$util.isEmpty(this.deviceInfoForm.iPSegment)) {
                    try {
                        // 验证IP段是否相同
                        let startIPRegin = this.deviceInfoForm.sIp.replace(/\.[0-9]{1,3}$/, '');
                        let endIPRegin = this.deviceInfoForm.iPSegment.replace(/\.[0-9]{1,3}$/, '');
                        if (startIPRegin == endIPRegin) {
                            // 验证结束ip是否大于开始ip
                            let start = this.deviceInfoForm.sIp.split('.')[3];
                            let end = this.deviceInfoForm.iPSegment.split('.')[3];
                            if (Number(start) > Number(end)) {
                                return callback(new Error(this.$t('pgError.ERROR_ENDIP_LARGE_STARTIP')));
                            } else {
                                this.$refs.deviceInfoForm.clearValidate('iPSegment');
                                return callback();
                            }
                        } else {
                            return callback(new Error(this.$t('pgError.ERROR_SAME_IP_REGION')));
                        }
                    } catch (err) {
                        return callback(new Error(this.$t('pgError.ERROR_IP_SEGMENT_CHECK')));
                    }
                } else {
                    callback();
                }
            };
            let iPSegmentCheck = (rule, value, callback) => {
                if (this.ursIpSegment && !this.$util.isEmpty(this.deviceInfoForm.sIp)) {
                    try {
                        // 验证IP段是否相同
                        let startIPRegin = this.deviceInfoForm.sIp.replace(/\.[0-9]{1,3}$/, '');
                        let endIPRegin = this.deviceInfoForm.iPSegment.replace(/\.[0-9]{1,3}$/, '');
                        if (startIPRegin == endIPRegin) {
                            // 验证结束ip是否大于开始ip
                            let start = this.deviceInfoForm.sIp.split('.')[3];
                            let end = this.deviceInfoForm.iPSegment.split('.')[3];
                            if (Number(start) > Number(end)) {
                                return callback(new Error(this.$t('pgError.ERROR_ENDIP_LARGE_STARTIP')));
                            } else {
                                this.$refs.deviceInfoForm.clearValidate('sIp');
                                return callback();
                            }
                        } else {
                            return callback(new Error(this.$t('pgError.ERROR_SAME_IP_REGION')));
                        }
                    } catch (err) {
                        return callback(new Error(this.$t('pgError.ERROR_IP_SEGMENT_CHECK')));
                    }
                } else {
                    callback();
                }
            };
            if (this.iPSegmentDisabled) {
                this.$refs.deviceInfoForm.clearValidate('sIp');
                this.$refs.deviceInfoForm.clearValidate('iPSegment');
                this.deviceInfoForm.iPSegment = '';
                if (this.rules.sIp.length == 3) {
                    this.rules.sIp.splice(-1, 1);
                }
                if (this.rules.iPSegment.length == 3) {
                    this.rules.iPSegment.splice(-1, 1);
                }
            } else {
                this.rules.sIp.push({ validator: iPCheck, trigger: 'blur' });
                this.rules.iPSegment.push({ validator: iPSegmentCheck, trigger: 'blur' });
            }
        },
        //查询扩展组标识信息
        getExtendGroupFlg() {
            let content = {
                deviceType: this.iDeviceTypes[0]
            };
            // 根据设备类型查询扩展组标识信息
            window.pgApi.queryExtendGroup(content, response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$message({
                        showClose: true,
                        message: this.$t('error.ERROR_RESPONSE'),
                        type: 'error'
                    });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('/device/queryExtendGroupByType', response.data.statusMessage);
                    return;
                }
                if (this.$util.isEmpty(response.data.content)) {
                    this.$log.info('/device/queryExtendGroupByType', response.data.content);
                    return;
                }
                if (this.$util.isEmpty(response.data.content.sExtendGroup)) {
                    this.displayDynamic = false;
                } else {
                    this.interExtendGroupFlg = response.data.content.sExtendGroup.split(',')[0];
                    this.displayDynamic = true;
                }
            });
        },
        // 所属设备下拉选择时执行的方法
        isChosen(data) {
            this.$refs.tdOrgDevTree.isSelect(data.device);
            if (!data.device) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_CHOOSE_DEVICE_NODE'), type: 'warning' });
            }
        },
        //回显所属设备（下拉选择树）
        showBelongDev(sId) {
            let content = [sId];
            window.pgApi.queryDeviceById(JSON.stringify(content), response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$message({
                        showClose: true,
                        message: this.$t('error.ERROR_RESPONSE'),
                        type: 'error'
                    });
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('/device/queryDeviceById', response.data.statusMessage);
                    return;
                }

                if (Array.isArray(response.data.content) && response.data.content.length > 0) {
                    let obj = {};
                    obj.caption = response.data.content[0].sName;
                    obj.sId = response.data.content[0].sId;
                    obj.deviceType = response.data.content[0].iDeviceType;
                    obj.device = true;
                    this.$refs.tdOrgDevTree.dataDisplay([obj]);
                }
            });
        },
        initEditData() {
            if (this.hasCoverInitEditData) {
                this.$emit('initEditData');
            } else {
                if (this.editItem) {
                    this.sId = this.editItem.sId;
                    this.deviceInfoForm.sDeviceId = this.editItem.sDeviceId;
                    this.deviceInfoForm.sName = this.editItem.sName;
                    this.deviceInfoForm.sIp = this.editItem.sIp;
                    this.deviceInfoForm.iIpType = this.editItem.iIpType;
                    if (this.masterServeDisplay && this.editItem.iProjectControl) {
                        this.deviceInfoForm.iProjectControl = this.editItem.iProjectControl;
                        this.parentDevDisplay = true;
                        this.masterServeDisabled = false;
                        if (this.deviceInfoForm.iProjectControl == 1) {
                            this.masterServeDisabled = true;
                            this.parentDevDisplay = false;
                        }
                    }
                    if (this.editItem.sDomainType) {
                        this.deviceInfoForm.sDomainType = this.editItem.sDomainType;
                    }
                    if (this.editItem.iIpType) {
                        this.iPTypeChange(this.editItem.iIpType);
                    }
                    this.deviceInfoForm.iPort = this.editItem.iPort;
                    this.deviceInfoForm.sDescription = this.editItem.sDescription;
                    if (this.editItem.sParentId) {
                        if (this.isOrgDevTree) {
                            this.showBelongDev(this.editItem.sParentId);
                        } else {
                            this.deviceInfoForm.sParentId = this.editItem.sParentId;
                        }
                    }
                    if (this.editItem.isSearch) {
                        this.autoIdDisabled = true;
                        this.rules.sDeviceId[0].required = false;
                    } else {
                        this.autoIdDisabled = false;
                    }
                    if (this.editItem.sExtendInfo) {
                        try {
                            this.extendElementValue = JSON.parse(this.editItem.sExtendInfo.replace(/\\/g, ''));
                        } catch (e) {
                            this.$message({
                                showClose: true,
                                message: this.$t('pgError.ERROR_MESSAGE_JSON'),
                                type: 'error'
                            });
                            this.$log.error('TdDeviceInfo.initEditData()', this.$t('pgError.ERROR_MESSAGE_JSON'));
                        }
                    }
                }
            }
        },

        // 域类型发生改变
        domainTypeChange(param) {
            this.$emit('dTypeChange', param);
            // 根据域类型，动态改变端口号默认值
            if (param === '4') {
                this.deviceInfoForm.iPort = 9000;
            } else {
                this.deviceInfoForm.iPort = 8000;
            }
        },

        // 提交数据
        submitForm(formName) {
            this.$log.info('submitForm');
            this.$refs[formName].validate(valid => {
                //默认扩展校验通过
                let dynamicCheck = true;
                if (!this.$util.isEmpty(this.interExtendGroupFlg) && this.$refs.tdDynamic && this.$refs.tdDynamic.$refs.dynamicForm) {
                    this.$refs.tdDynamic.$refs.dynamicForm.validate(validDynamic => {
                        dynamicCheck = validDynamic;
                    });
                }
                if (valid && dynamicCheck) {
                    this.loading = true;
                    //回掉父组件设置保存设备的类型
                    let submitDevType = this.iDeviceTypes[0];
                    this.$emit('setSubmitDevType', submitDevType, function(type) {
                        if (type) {
                            submitDevType = type;
                        }
                    });
                    let content = {
                        sName: this.deviceInfoForm.sName,
                        sDeviceId: this.deviceInfoForm.sDeviceId,
                        iIpType: this.deviceInfoForm.iIpType,
                        sIp: this.deviceInfoForm.sIp,
                        iPSegment: this.deviceInfoForm.iPSegment,
                        usrIpSegment: this.deviceInfoForm.usrIpSegment,
                        iPort: this.deviceInfoForm.iPort,
                        sDescription: this.deviceInfoForm.sDescription,
                        iProjectControl: this.deviceInfoForm.iProjectControl,
                        sDomainType: this.deviceInfoForm.sDomainType,
                        iDeviceType: submitDevType,
                        isAddData: this.isAddData,
                        sParentId: this.deviceInfoForm.sParentId === null ? '' : this.deviceInfoForm.sParentId,
                        sExtendInfo: this.extendElementValue,
                        sId: this.sId,
                        sOrgId: this.orgId,
                        sDeviceInfo: ''
                    };

                    if (this.isHandleData) {
                        //保存时是否处理表单数据
                        this.$emit('handleDataMethod', content, function(data) {
                            if (data) {
                                content = data;
                            }
                        });
                    }
                    if (this.$refs.tdDynamic) {
                        let extendData = this.$refs.tdDynamic.getfromInfo();
                        //保存时是否处理扩展元素数据
                        if (this.isHandleExtendData) {
                            this.$emit('handleExtendDataMethod', extendData, function(data) {
                                if (data) {
                                    extendData = data;
                                }
                            });
                        }
                        content.sExtendInfo = extendData;
                    }

                    if (this.isOrgDevTree) {
                        let deviceNode = this.$refs.tdOrgDevTree.getSelectedNodes();
                        content.sParentId = deviceNode ? deviceNode.sId : '';
                    }
                    //提交表单前判断逻辑
                    let isSubmitForm = true;
                    if (this.beforeSubmitForm != undefined) {
                        isSubmitForm = this.beforeSubmitForm(content);
                    }
                    if (isSubmitForm) {
                        window.pgApi.saveDevice(JSON.stringify(content), response => {
                            this.loading = false;
                            if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                                this.$message({
                                    showClose: true,
                                    message: this.$t('error.ERROR_RESPONSE'),
                                    type: 'error'
                                });
                                return;
                            }
                            if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                                if (this.isEnablePromptInformation) {
                                    const promptInformation = this.promptCode.filter(item => item.code === response.data.statusCode);
                                    if (promptInformation !== undefined && promptInformation.length > 0) {
                                        this.$message({
                                            showClose: true,
                                            message: response.data.statusMessage,
                                            type: promptInformation[0].messageType
                                        });
                                        this.$log.error('/device/saveDevice', response.data.statusMessage);
                                        return;
                                    } else {
                                        this.$message({
                                            showClose: true,
                                            message: response.data.statusMessage,
                                            type: 'error'
                                        });
                                        this.$log.error('/device/saveDevice', response.data.statusMessage);
                                        return;
                                    }
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: response.data.statusMessage,
                                        type: 'error'
                                    });
                                    this.$log.error('/device/saveDevice', response.data.statusMessage);
                                    return;
                                }
                            }
                            let successMessage = response.data.statusMessage;
                            if (this.diySuccessMessage) {
                                successMessage = this.diySuccessMessage;
                            }
                            //是否提示所属设备已修改，请下传设置
                            if (this.downloadSettingsTip && !this.$util.isEmpty(content.sParentId) && content.sParentId != this.editItem.sParentId) {
                                successMessage = this.$t('pgMessage.BELONG_DEVICE_CHANGE_DOWNLOAD_SETTING');
                            }
                            this.$message({
                                showClose: true,
                                message: successMessage,
                                type: 'success'
                            });
                            this.$emit('submit');
                            if (this.isCloseDialog) {
                                this.dlalogClose();
                            }
                        });
                    } else {
                        this.loading = false;
                    }
                }
            });
        },
        // 所属设备change事件
        belongDevChange(value) {
            this.$emit('belongDevChange', value);
        },
        // 关闭窗口之前需要调用的方法
        dlalogClose() {
            this.$log.info('dlalogClose');
            this.$emit('dlalogClose');
            this.$refs['deviceInfoForm'].resetFields(); // 重置表单数据
        },
        // 自动生成id
        autoCreateId(value) {
            if (value) {
                if (this.fatherAutoCreateId) {
                    this.autoIdDisabled = true;
                    this.rules.sDeviceId[0].required = false;
                    this.deviceInfoForm.sDeviceId = this.fatherAutoCreateId();
                } else {
                    this.rules.sDeviceId[0].required = false;
                    this.autoIdDisabled = true;
                    this.deviceInfoForm.sDeviceId = null;
                }
            } else {
                this.autoIdDisabled = false;
                this.rules.sDeviceId[0].required = true;
            }
        },
        checkDevEmpty(rule, value, callback) {
            if (this.$util.isEmpty(this.deviceInfoForm.sDeviceId)) {
                const message = this.$t('pgError.ERROR_DEVICE_NULL');
                callback(message);
            }
            callback();
        },
        // 改变是否总控状态
        changeCeneral(value) {
            this.deviceInfoForm.sParentId = null;
            this.rules['sParentId'] = [];
            if (value == 1) {
                this.parentDevDisabled = true;
            } else {
                this.parentDevDisabled = false;
                this.rules['sParentId'].push({
                    required: true,
                    validator: this.checkParentDevEmpty,
                    trigger: 'change'
                });
            }
        },
        checkParentDevEmpty(rule, value, callback) {
            if (this.$util.isEmpty(this.deviceInfoForm.sParentId)) {
                const message = this.$t('common.PLEASE_SELECT');
                callback(message);
            }
            callback();
        },
        tdDynamicHeight(idx) {
            this.curSteps = idx;
        },
        //在点击时，清除所属设备的校验
        visibleChange() {
            this.$refs.deviceInfoForm.clearValidate('sParentId');
        }
    }
};
</script>
<style scoped>
.footerBtnStyle {
    height: 35px !important;
    margin-top: 20px !important;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.inputNumberPort >>> .el-input-number {
    position: relative;
    display: block;
    width: 180px;
    line-height: 38px;
}
/deep/.el-col {
    height: 55px;
}
</style>
